import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { I18nProvider } from './i18n/index.js';
import { AccountProvider } from './session/useAccount.js';
import { SessionProvider } from './session/useSession.js';
import { WatchlistProvider } from './session/useWatchlist.js';
import { registerServiceWorker } from './lib/registerServiceWorker.js';
import { watchForInstallPrompt } from './lib/installPrompt.js';
import './styles.css';

registerServiceWorker();
// Before React mounts, deliberately: the browser fires `beforeinstallprompt`
// during the first load, and an offer nobody caught is an offer that is gone.
watchForInstallPrompt();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      {/* Outermost of the three, because both of the others can belong to a
          signed-in person: the account decides whose watchlist is whose, and
          whether the ad slots render at all. */}
      <AccountProvider>
        <WatchlistProvider>
          <SessionProvider>
            <App />
          </SessionProvider>
        </WatchlistProvider>
      </AccountProvider>
    </I18nProvider>
  </StrictMode>,
);
